import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'

Vue.use(VueFeather)
Vue.use(flatPickr)
Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

if (process.env.VUE_APP_TEST === 'e2e') {
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.component('apexchart', VueApexCharts)

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')


if (process.env.VUE_APP_TEST === 'e2e') {
  window.__app__ = app
}
